import type { TFunction } from 'i18next';

/**
 * Wave 1C — the audit log's "what changed" line used to print the RAW field
 * name the API emitted (`grandTotal`, `rateEffectiveOn`), in English, in both
 * languages. Every field a purchasing document's audit rows emit has an
 * `audit.field.<name>` key in both dictionaries; a field nobody has named
 * yet falls back to a humanised form of its own name rather than to the
 * literal key text, so a new field reads as words on the day it appears.
 *
 * The fallback is the ONLY place a field name is prettified; the dictionary
 * wins whenever it answers, which is what makes the Arabic screen Arabic.
 */
export function fieldLabel(t: TFunction, field: string): string {
  return t(`audit.field.${field}`, { defaultValue: humaniseField(field) });
}

/**
 * `cancellationJournalEntryId` → "Cancellation journal entry id",
 * `supplier_invoice_no` → "Supplier invoice no", `3` → "3". Pure, so it can
 * be pinned without a renderer.
 */
export function humaniseField(field: string): string {
  const spaced = field
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .trim()
    .toLowerCase();
  if (spaced === '') return field;
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
